import Select from 'react-select';
import styles from './CustomSelect.module.scss';

export default function CustomSelect({
  placeholder,
  options,
  value,
  onSelect,
  closeMenuOnSelect = true,
}) {
  return (
    <Select
      className={styles.select}
      classNames={{
        control: (state) => `${styles.select_control} ${state.isFocused ? styles.select_control + '--is-focused' : ''}`,
        singleValue: (state) => styles.select_single_value,
        input: (state) => styles.select_input,
        valueContainer: (state) => styles.select_value_container,
        indicatorSeparator: (state) => styles.select_indicator_separator,
        indicatorsContainer: (state) => styles.select_indicators,
        dropdownIndicator: (state) => styles.select_dropdown_indicator,
        placeholder: (state) => styles.select_placeholder,
        menu: (state) => styles.select_menu,
        menuList: (state) => styles.select_menu_list,
        option: (state) => `${styles.select_option} ${state.isFocused ? styles.select_option + '--is-focused' : ''} ${state.isSelected ? styles.select_option + '--is-selected' : ''}`
      }}
      closeMenuOnSelect={closeMenuOnSelect}
      placeholder={placeholder}
      options={options}
      value={value}
      onChange={onSelect}
    />
  )
}
